import { Link } from "react-router-dom";

const ContentTypesTable = ({ contentTypes, getContentType, onDelete }) => {
  return (
    <div className="col-md-12 col-lg-8">
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Row Number</th>
            <th>Is Original</th>
            <th className="text-end">Action</th>
          </tr>
        </thead>
        {/* Table Data */}
        <tbody>
          {contentTypes?.map((cate) => (
            <tr key={cate.id}>
              <td>
                <b>{cate.name}</b>
              </td>
              <td>{cate.type}</td>
              <td>{cate.row_number}</td>
              <td>{cate.is_original ? "Yes" : "No"}</td>
              <td className="text-end">
                <div className="dropdown">
                  <Link
                    to="#"
                    data-bs-toggle="dropdown"
                    className="btn btn-light"
                  >
                    <i className="fas fa-ellipsis-h"></i>
                  </Link>
                  <div className="dropdown-menu">
                    <div
                      className="dropdown-item"
                      onClick={() => {getContentType(cate.id)}}
                    >
                      Edit info
                    </div>
                    <div className="dropdown-item text-danger" onClick={()=>{onDelete(cate.id)}}>
                      Delete
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContentTypesTable;
